import { StyleSheet } from 'react-native';

export const Styles = StyleSheet.create({
  background: {
    backgroundColor: 'black',
    flex: 1,
  },
});
